import { render } from "./PsLoadingDialog.vue?vue&type=template&id=131dd83b&ts=true"
import script from "./PsLoadingDialog.vue?vue&type=script&lang=ts"
export * from "./PsLoadingDialog.vue?vue&type=script&lang=ts"

import exportComponent from "G:\\wamp\\www\\vahanwale\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__